const Username = ({ user }) => {
  const { name, nickname } = user || {};
  if (nickname && name) {
    return `${nickname} ${name}`;
  }
  return nickname || name || "";
};

export default Username;
